enum CommissionAppPaths {
  Home = '/',
  Commission = '/qr-commission',
  Scan = '/qr-scan',
  NotFound = '/*',
}

export default CommissionAppPaths;
